$(document).ready(function(){
  if($('body.product')){  
    const defaultNoticeInnerHTML = `<p class="customily_modal_preview--title">Please check the preview carefully</p> <p class="customily_modal_preview--notice_content"><em>Make sure the below customization is correct to receive your item faster</em></p>`
    
    function handleFakeBtnClick(t) {
      t.stopPropagation(),
        document.querySelector(".btn-preview-add-to-cart").classList.add("running");
      document.querySelector(".add_to_cart_js").click();
    }
    
    function mainFunc(item) {
      if (item.classList !== null && item.classList !== void 0) {
        if (item.classList.contains('canvas-container')) {
          let t = document.querySelector(".add_to_cart_js");
          let e = document.querySelector(".customily-modal-preview-only .main");
          
          let f = document.createElement('div');
          let g = document.createElement('button');

          g.innerHTML = 'Close';
          g.className = 'customily-close-btn';
    
          t.classList.add("btn-preview-add-to-cart");
          
          f.className = 'btn-wrapper';
          f.appendChild(t);
          f.appendChild(g);
          
          e.appendChild(f);
          t.addEventListener("click", function (t) {
            return handleFakeBtnClick(t);
          });
          g.addEventListener("click", function (t) {
            t.stopPropagation();
            t.preventDefault();
            // t.closest('.customily-modal-preview-only').find('.customily-close-button').click();
            document.querySelector(".customily-close-button").click();
          });
          const formWrapper = document.querySelector('.product_form');
          
          var modifyNoticeEl = document.createElement('div');
          modifyNoticeEl.className = 'customily_modal_preview--modify_notice';
          
          modifyNoticeEl.innerHTML = defaultNoticeInnerHTML;
          e.appendChild(modifyNoticeEl)
        }
      }
    }  
    (function () {
      try {
        const observer = new MutationObserver(function (t) {
          t.forEach(function (t) {
            if (t.addedNodes) {
              for (var r = 0; r < t.addedNodes.length; r++) {
                var e = t.addedNodes[r];
                mainFunc(e);
              }
            }
          });
        });
        observer.observe(document.body, {
          childList: true,
          subtree: true,
          attributes: false,
          characterData: false,
        });
      } catch (error) {
        console.log(error);
      }
    })();
  }
});